import maplibregl from 'maplibre-gl';

export const nspdTool = {
  _map: null,
  _marker: null,
  _onNSPDSelect: null,

  initialize: (map, options) => {
    console.log('NSPD search tool initialized');
    nspdTool._map = map;
    nspdTool._onNSPDSelect = options.onNSPDSelect;
  },
  activate: () => {
    console.log('NSPD search tool activated');
    nspdTool._map.getCanvas().style.cursor = 'help';
    nspdTool._map.on('click', nspdTool.handleMapClick);
  },
  deactivate: () => {
    console.log('NSPD search tool deactivated');
    nspdTool._map.getCanvas().style.cursor = '';
    nspdTool._map.off('click', nspdTool.handleMapClick);
    nspdTool.cleanup();
  },
  cleanup: () => {
    if (nspdTool._marker) {
      nspdTool._marker.remove();
      nspdTool._marker = null;
    }
  },
  handleMapClick: (e) => {
    nspdTool.cleanup();

    const { lng, lat } = e.lngLat;
    
    // Вызываем колбэк для панели NSPD
    nspdTool._onNSPDSelect?.({ coordinates: { lng, lat } });

    // Ставим временный маркер
    nspdTool._marker = new maplibregl.Marker({ color: '#2563eb' })
      .setLngLat(e.lngLat)
      .addTo(nspdTool._map);
  },
};
